"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var InputReset = function InputReset() {
  return "\n  appearance: none;\n  background: none;\n  border: none;\n  border-radius: 0;\n  cursor: pointer;\n  font-family: \"proxima-nova\";\n";
};

exports.default = InputReset;